The identifier for the `DraftApplicationQuestionnaireComponent`.
